module.exports = __webpack_public_path__ + "img/doorLogo4.e2198c67.png";